import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  })
};
export function HeroSection() {
  return <section className="w-full min-h-screen flex items-center justify-center px-5 py-16 md:py-24" style={{
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-78">
      <div className="max-w-6xl w-full mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-79">
        {/* Text content */}
        <div className="flex-1 max-w-xl" data-id="element-80">
          <motion.p custom={0} initial="hidden" animate="visible" variants={fadeUp} className="text-sm md:text-base font-semibold uppercase tracking-widest mb-6" style={{
          color: 'var(--color-sage)'
        }} data-id="element-81">
            Mamá 10-Minutos
          </motion.p>

          <motion.h1 custom={1} initial="hidden" animate="visible" variants={fadeUp} className="text-4xl md:text-5xl lg:text-6xl leading-tight md:leading-tight lg:leading-tight mb-6" style={{
          color: 'var(--color-tan)',
          fontFamily: "'DM Serif Display', serif"
        }} data-id="element-82">
            No te falta disciplina.{' '}
            <span style={{
            color: 'var(--color-slate)'
          }} data-id="element-83">
              Te falta un plan que sobreviva a tus hijos.
            </span>
          </motion.h1>

          <motion.p custom={2} initial="hidden" animate="visible" variants={fadeUp} className="text-lg md:text-xl leading-relaxed mb-4" style={{
          color: 'var(--color-slate)',
          opacity: 0.8
        }} data-id="element-84">
            10 minutos. Sin gym. Sin saltos. Sin empezar de cero cada semana.
          </motion.p>

          <motion.p custom={3} initial="hidden" animate="visible" variants={fadeUp} className="text-base md:text-lg leading-relaxed mb-8" style={{
          color: 'var(--color-slate)',
          opacity: 0.6
        }} data-id="element-85">
            Un sistema de 21 días diseñado para mamás reales con vidas reales.
          </motion.p>

          <motion.a custom={4} initial="hidden" animate="visible" variants={fadeUp} href="#cta" className="inline-flex items-center gap-3 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-[#C4A88240] hover:scale-[1.03]" style={{
          backgroundColor: 'var(--color-tan)',
          color: 'var(--color-slate)'
        }} data-id="element-86">
            Descárgalo ahora — $29
            <ChevronRightIcon className="w-5 h-5" data-id="element-87" />
          </motion.a>
        </div>

        {/* Product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="flex-1 max-w-md w-full" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/jwmn9Q2ZfFsHSEvz4H2CyF/heylloyd-image-1770692828619.png" alt="Mamá 10-Minutos: Cuerpo Firme Sin Gym — vista del programa en tablet y teléfono" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-89" />
        </motion.div>
      </div>
    </section>;
}